import { Box } from '@mantine/core';
import { PageTitle } from 'components/PageTitle';
import { i18nKeys, useTranslation } from 'locales';
import { AiCallTab } from 'modules/Reminders/components';
import { useParams } from 'react-router-dom';

import { useLoadAiCall } from '../api/use-load-ai-call';

type AiCallProps = {};

export const AiCall = ({}: AiCallProps) => {
  const { t } = useTranslation();

  const { id } = useParams<{ id: string }>();

  const { aiCall, isAiCallInitialLoading } = useLoadAiCall({ id });

  return (
    <>
      <PageTitle overrideTitle={`${t(i18nKeys.AI_CALL)} - ${aiCall.debtorName}`}>
        {t(i18nKeys.AI_CALL)}
        <PageTitle.Back />
      </PageTitle>
      <Box>
        <AiCallTab
          aiCall={aiCall}
          debtorId={aiCall.debtorId}
          debtorFullName={aiCall.debtorName}
          isLoading={isAiCallInitialLoading}
        />
      </Box>
    </>
  );
};
